import React, { useState, useEffect } from 'react';
import { truncateFileName } from '@utils/commons';
import Pagination from '@components/pagination';
import { Link, AboutMeTypesFromData } from '../StepThreeTypes';

interface MultiMediaUrlProps {
  aboutMeFromData: AboutMeTypesFromData;
  mediaUrlList: Link[];
  setMediaUrlList: React.Dispatch<React.SetStateAction<Link[]>>;
  mediaUrl: string;
  setMediaUrl: React.Dispatch<React.SetStateAction<string>>;
}

const MultiMediaUrl: React.FC<MultiMediaUrlProps> = ({
  aboutMeFromData,
  mediaUrlList,
  setMediaUrlList,
  mediaUrl,
  setMediaUrl,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentItems, setCurrentItems] = useState<Link[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 10;

  useEffect(() => {
    setCurrentItems(
      mediaUrlList?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      ) || []
    );

    const total = mediaUrlList
      ? Math.ceil(mediaUrlList.length / itemsPerPage)
      : 0;
    setTotalPages(total);

    if (currentPage > total && total > 0) {
      setCurrentPage(total);
    }
  }, [currentPage, mediaUrlList]);

  useEffect(() => {
    setMediaUrlList(aboutMeFromData.multiMediaUrl);
  }, [aboutMeFromData.multiMediaUrl, setMediaUrlList]);

  const handleDeleteFile = (e: any, key: string) => {
    e.preventDefault();
    const newUrlList: Link[] = mediaUrlList?.filter(file => file.id !== key);
    setMediaUrlList(newUrlList);
  };

  return (
    <div>
      <div className="govuk-form-group mt-10 govuk-bp:mt-14">
        <h1 className="govuk-label-wrapper">
          <label
            className="govuk-label govuk-label--l"
            htmlFor="multi-media-url"
          >
            Multi-Media URL
          </label>
        </h1>
        <div id="multimedia-url-hint" className="govuk-hint">
          You can enter a URL or a link to a multi-media file when a multi-media
          file is stored in a different system.
        </div>
        <input
          className="govuk-input"
          id="multi-media-url"
          name="multiMediaUrl"
          type="text"
          aria-describedby="multi-media-url-hint"
          value={mediaUrl}
          onChange={e => setMediaUrl(e.target.value)}
        />
      </div>
      {currentItems && currentItems?.length > 0 && (
        <div>
          <table className="govuk-table">
            <thead className="govuk-table__head">
              <tr className="govuk-table__row">
                <th
                  scope="col"
                  className="govuk-table__header govuk-!-width-three-quarters"
                >
                  File Name
                </th>
                <th
                  scope="col"
                  className="govuk-table__header govuk-!-width-one-quarter"
                >
                  {' '}
                </th>
              </tr>
            </thead>
            <tbody className="govuk-table__body">
              {mediaUrlList.map((link: Link) => (
                <tr className="govuk-table__row" key={link.id}>
                  <td className="govuk-table__cell column-1" title={link.url}>
                    {truncateFileName(link.url, 50)}
                  </td>
                  <td className="govuk-table__cell">
                    <div className="govuk-button-group">
                      <button
                        type="button"
                        className="govuk-button"
                        data-module="govuk-button"
                        onClick={() => window.open(link.url, '_blank')}
                      >
                        Open
                      </button>
                      <button
                        type="button"
                        className="govuk-button govuk-button--warning"
                        data-module="govuk-button"
                        onClick={e => handleDeleteFile(e, link.id)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </div>
      )}
    </div>
  );
};

export default MultiMediaUrl;
